import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user.class';
import { LoginService } from './login.service';
import { Subscription } from 'rxjs/Subscription';
import { CookieService } from '../../_services/cookie.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { LocalService } from '../../_services/local.service';
import { NotificationService } from '../../_services/notification.service';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit, OnDestroy {
  public user: any = {};
  public showError: boolean = false;
  // tslint:disable-next-line: no-inferrable-types
  public showUpdateError: boolean = false;
  public errorString: string = '';
  public loadingClass: string = 'register-hr';
  public returnUrl: string = '';
  public subscription: Subscription;
  public loginladda = false;
  public openForgetPasswordDialog = false;
  public openEmailSendDialog = false;
  public Email: string = '';
  timeRemaining: string = '1:00'; // Initial value
  public resendButtonDisable: boolean = true;
  private timerSubscription!: Subscription;

  public emailNotFound:boolean = false;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private _loginService: LoginService,
    private _authenticationService: AuthenticationService,
    private _localService: LocalService,
    private _cookieService: CookieService,
    public _notificationService: NotificationService,) {
    let element = document.getElementsByTagName(`body`)[0];
    element.classList.remove(`sidebar-lg-show`);
  }

  ngOnInit() {
    this.subscription = this.route.queryParams.subscribe(
      (params: any) => {
        if (params.hasOwnProperty('returnUrl')) {
          this.returnUrl = params['returnUrl'];
        }
      }
    );
    if (this._cookieService.getCookie('ussr')) {
      this.router.navigate(['/dashboard']);
    }
  }

  public login() {
    this.loading(true);
    this._loginService.login({ username: this.user.username, password: this.user.password }).subscribe((response: any) => {
      debugger
      if (this._authenticationService.setUser(response)) {
        this.loading(false);
        this.router.navigate([`/${this.returnUrl}`]);
      }
    }, (err) => {
      debugger
      if (err.error == "User has been disabled" || (err.error && err.error.error_description && err.error.error_description == 'NA')) {
        this.showUpdateError = true;
      }
      else {
        this.showUpdateError = false;
        this.showError = true;
      }
      this.loading(false);
    }
    );
  }

  //Loading Helper Function
  public loading(start: boolean) {
    if (start) {
      this.loadingClass = 'register-hr-anime';
    } else {
      this.loadingClass = 'register-hr';
    }
    this.loginladda = true;
  }

  public OpenForgetPasswordDialog(){
    this.openForgetPasswordDialog = true;
  }
  close (){
    this.openForgetPasswordDialog = false;  
    this.openEmailSendDialog = false;
  }

  public onSubmitPasswordForget() {
    debugger
         this.loading(true);
         this._loginService.sendForgetPasswordEmail(this.Email).subscribe((response: any) => {
           debugger
           this.openForgetPasswordDialog = false;
           this.openEmailSendDialog = true;
           this.loading(false);
           this.startCountdown(60);
         }, (err) => {
           debugger
           this.emailNotFound = true;
           this.loading(false);
         }
         );
      }

  
      startCountdown(seconds: number): void {
        this.timerSubscription = interval(1000) // Emit every 1 second
          .pipe(take(seconds)) // Limit emissions to the specified seconds
          .subscribe((elapsed) => {
            const remaining = seconds - elapsed - 1; // Calculate remaining seconds
            const minutes = Math.floor(remaining / 60);
            const secondsLeft = remaining % 60;
    
            this.timeRemaining = `${minutes}:${secondsLeft < 10 ? '0' : ''}${secondsLeft}`; // Format time
    
            if (remaining <= 0) {
              this.resendButtonDisable = false;
              this.timeRemaining = 'Time is up!'; // Optional: Show "time is up" message
            }
          });
      }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
